function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6 30.5h45l-5.143 25H11.143zM2 24.5h53v6H2zM18.765.429s1.58-.284 2.235.07c.656.355 1.284 1.831 1.284 1.831L10.401 24.326s-1.58.283-2.235-.071c-.656-.355-1.284-1.83-1.284-1.83zM38.401.429s-1.58-.284-2.235.07c-.656.355-1.284 1.831-1.284 1.831l11.883 21.996s1.58.283 2.235-.071c.656-.355 1.284-1.83 1.284-1.83z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.51 51.08s-1.253.684-1.998.684c-.746 0-2.001-.682-2.001-.682L14.489 34s1.254-.684 2-.684c.745 0 2 .682 2 .682zM26.51 51.08s-1.253.684-1.998.684c-.746 0-2.001-.682-2.001-.682L22.489 34s1.254-.684 2-.684c.745 0 2 .682 2 .682zM34.51 51.08s-1.253.684-1.998.684c-.746 0-2.001-.682-2.001-.682L30.489 34s1.254-.684 2-.684c.745 0 2 .682 2 .682zM42.51 51.08s-1.253.684-1.998.684c-.746 0-2.001-.682-2.001-.682L38.489 34s1.254-.684 2-.684c.745 0 2 .682 2 .682z"
}));

var SvgBasket = function SvgBasket(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBasket, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Basket.029df11d.svg";
export { ForwardRef as ReactComponent };